<ng-template vdrDialogTitle>{{
  "common.create-new" | translate : params
}}</ng-template>

<vdr-page-block>
  <vdr-action-bar>
    <vdr-ab-left>
      <div class="flex clr-flex-row"></div>
      <!-- <vdr-language-selector
        [disabled]="isNew$ | async"
        [availableLanguageCodes]="availableLanguages$ | async"
        [currentLanguageCode]="languageCode$ | async"
        (languageCodeChange)="setLanguage($event)"
      ></vdr-language-selector> -->
    </vdr-ab-left>
    <vdr-ab-right>
      <button
        class="btn btn-primary"
        (click)="create()"
        [disabled]="detailForm.invalid || detailForm.pristine"
      >
        {{ "common.create" | translate }}
      </button>
    </vdr-ab-right>
  </vdr-action-bar>
</vdr-page-block>

<form class="form" [formGroup]="detailForm">
  <vdr-page-detail-layout>
    <vdr-page-detail-sidebar>
      <!-- <vdr-card *ngIf="entity$ | async as entity">
        <vdr-page-entity-info [entity]="entity" />
      </vdr-card> -->
    </vdr-page-detail-sidebar>

    <vdr-page-block>
      <vdr-card>
        <div class="form-grid">
          <vdr-form-field [label]="'Language Code'" for="languageCode">
            <vdr-language-code-selector
              formControlName="languageCode"
              [languageCodes]="languageCodes"
            ></vdr-language-code-selector>
          </vdr-form-field>
          <vdr-form-field [label]="'Title'" for="title">
            <input
              id="title"
              type="text"
              formControlName="title"
              [readonly]="!(updatePermissions | hasPermission)"
            />
          </vdr-form-field>
          <vdr-form-field
            class="form-grid-span"
            [label]="'Top description'"
            for="topDescription"
          >
            <custom-rich-text-editor
              formControlName="topDescription"
              [readonly]="!(updatePermissions | hasPermission)"
            ></custom-rich-text-editor>
          </vdr-form-field>
          <vdr-form-field
            class="form-grid-span"
            [label]="'Bottom description'"
            for="bottomDescription"
          >
            <custom-rich-text-editor
              formControlName="bottomDescription"
              [readonly]="!(updatePermissions | hasPermission)"
            ></custom-rich-text-editor>
          </vdr-form-field>
        </div>
      </vdr-card>
    </vdr-page-block>
  </vdr-page-detail-layout>
</form>
